var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productfeature"},[_c('ul',_vm._l((_vm.data),function(item,index){return _c('li',{key:index},[_c('span',[_vm._v("＞")]),_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }